import { Link } from '@chakra-ui/react'
import type { LinkProps } from '@chakra-ui/react'
import { Link as RouterLink } from '@tanstack/react-router'

interface IInternalLinkProps extends LinkProps {
  name: string | number
  href: string
  state?: any
}

export const InternalLink = ({
  name,
  href,
  state,
  ...props
}: IInternalLinkProps) => (
  <Link asChild {...props}>
    <RouterLink to={href} state={state}>
      {name}
    </RouterLink>
  </Link>
)
